/* unplugin-vue-components disabled */import script from "./DesItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesItem.vue?vue&type=script&setup=true&lang=ts"

import "./DesItem.vue?vue&type=style&index=0&id=5f143afc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f143afc"]])

export default __exports__